<template>
  <asc-page-loading-indicator
    :loading="isDerivedParametersLoading && !apiPageFailure.length"
  >
    <v-container v-if="!isDerivedParametersPageActive" fluid>
      <asc-page-coming-soon label="Custom Parameters page Coming Soon!" />
    </v-container>
    <v-container v-else fluid class="asc-derived-parameter-list-container">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <asc-page-header>
            <template #pageTitle>
              <asc-page-title title="Custom Parameters" />
            </template>
          </asc-page-header>
        </v-col>
      </v-row>
      <asc-container>
        <asc-derived-parameter-list-template
          :tab-index="tabIndex"
          :on-tab-change="handleTabChange"
          :values="mappedDerivedParameters"
          :is-airline-user="isAirlineUser"
          :user-airlines="mappedUserAirlines"
          :hide-action-footer="hideActionFooter"
          :loading="isDerivedParametersLoading && !apiPageFailure.length"
          @onDeleteDerivedParameters="handleDeleteDerivedParameters"
          @onAddNewParameter="handleAddNewParameter"
          @openAlertTypeDialog="handleAddNewParameter"
          @copyParameter="handleCopyParameter"
        ></asc-derived-parameter-list-template>
      </asc-container>
      <asc-derived-parameter-choose-airline-dialog
        :show-dialog="chooseAirlineDialogVisible"
        :title="chooseAirlineTitle"
        sub-text="Choose which Airline you would like to create a parameter for:"
        :airlines="airlinesByTier"
        :mapped-acmf-master-models="getPlatformsData"
        :on-close="handleChooseAirlineDialogClose"
        :on-accept="handleChooseAirline"
        :display-airline="displayAirline"
        :display-platform="displayPlatform"
      />
      <asc-dialog
        :show-dialog="showDeleteConfirmationDialog"
        text="Delete selected parameters?"
        :loading="isDerivedParametersLoading"
        :on-primary="handleDeleteParameterConfirmation"
        :on-secondary="cancelDelete"
        secondary-button-text="Cancel"
        primary-button-text="Delete Parameters"
      >
        Are you sure you want to delete the selected parameters?
      </asc-dialog>
      <asc-confirmation
        v-if="showDeleteParameterConfirmationToast"
        :definition="deleteParametersConfirmationToastDefinition"
        :on-close="handleCloseDeleteParameterConfirmationmToast"
      ></asc-confirmation>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscPageHeader from '../../../atoms/AscPageHeader.vue'
import AscPageTitle from '../../../atoms/AscPageTitle.vue'
import AscPageComingSoon from '../../../molecules/AscPageComingSoon.vue'
import { AscDerivedParameterListTemplate } from '../../../templates'
import AscDerivedParameterChooseAirlineDialog from '../../../molecules/AscDerivedParameterChooseAirlineDialog.vue'
import AscDialog from '../../../atoms/AscDialog.vue'
import AscContainer from '../../../atoms/AscContainer.vue'
import AscConfirmation from '../../../molecules/AscConfirmation.vue'
import AppFeatureFlags from '../../../../utilities/appFeatureFlags'
import {
  LOOKUP_CONSTS as LC,
  USER_CONSTS as UC,
  CUSTOM_ALERTS_DERIVED_PARAMETERS_CONSTS as CA_DPC,
  GLOBAL_FILTER_CONSTS as GF,
  AIRLINE_MANAGEMENT_CONSTS as AOC,
} from '../../../../stores/consts'
import { mapGetters, mapState, mapActions } from 'vuex'
import {
  FULL_FLIGHT_TIER_2,
  COLLINS_PHM_TIER_3,
  COLLINS_PHM_TIER_4,
} from '@/utilities/appConsts'

export default {
  name: 'AscDerivedParameterListContainer',

  components: {
    AscPageLoadingIndicator,
    AscPageHeader,
    AscPageTitle,
    AscPageComingSoon,
    AscDerivedParameterListTemplate,
    AscDerivedParameterChooseAirlineDialog,
    AscConfirmation,
    AscContainer,
    AscDialog,
  },

  data() {
    return {
      isRouterPushed: false,
      tabIndex: 0,
      isDerivedParametersLoading: false,
      chooseAirlineDialogVisible: false,
      helpAboutGridDataLength: 0,
      helpAboutSelectedRows: [],
      footerActionDisabled: false,
      showDeleteParameterConfirmationToast: false,
      selectedParametersToDelete: null,
      showDeleteConfirmationDialog: false,
      hideActionFooter: false,
      deleteParametersConfirmationToastDefinition: [],
      airlineTiers: [
        {
          agreementTypeId: COLLINS_PHM_TIER_4, //This is for work item 20082; currently we only want to display Collins PHM Agreement airlines
        },
        {
          agreementTypeId: COLLINS_PHM_TIER_3,
        },
        {
          agreementTypeId: FULL_FLIGHT_TIER_2,
        },
      ],
      saveDisabled: true,
      saveLoading: false,
      displayAirline: false,
      displayPlatform: false,
      chooseAirlineTitle: '',
    }
  },

  computed: {
    ...mapGetters(UC.NAMESPACE, ['isAirlineUser', 'mappedUserAirlines']),
    ...mapState(CA_DPC.NAMESPACE, ['derivedParameters']),
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(GF.NAMESPACE, ['globalFilter']),
    ...mapState(AOC.NAMESPACE, ['airlinesByTier']),
    ...mapGetters(LC.NAMESPACE, [
      'mappedLuMasterModelsAll',
      'mappedAirlineMasterModelAgreement',
    ]),

    isDerivedParametersPageActive() {
      return AppFeatureFlags.getDerivedParameters()
    },

    mappedDerivedParameters() {
      return this.derivedParameters.map(parameterObj => {
        return {
          ...parameterObj,
          alertType: 'Full Flight',
        }
      })
    },
    getPlatformsData() {
      let val = this.mappedLuMasterModelsAll
        .filter(f => {
          return this.airlinesByTier.some(s => s.airlineId === f.airlineId)
        })
        .filter(f =>
          this.mappedAirlineMasterModelAgreement.some(
            s =>
              [
                COLLINS_PHM_TIER_4,
                FULL_FLIGHT_TIER_2,
                COLLINS_PHM_TIER_3,
              ].includes(s.agreementTypeId) &&
              s.airlineId == f.airlineId &&
              s.value == f.value,
          ),
        )
      return val
    },
    getUniquePlatformsData() {
      var uniquePlatforms = []
      this.mappedLuMasterModelsAll
        .filter(f => {
          return this.airlinesByTier.some(s => s.airlineId === f.airlineId)
        })
        .map(masterModel => {
          return {
            text: masterModel.text,
            value: masterModel.value,
            masterModelId: masterModel.masterModelId,
          }
        })
        .filter(function (masterModel) {
          var i = uniquePlatforms.findIndex(x => x.value == masterModel.value)
          if (i <= -1) {
            uniquePlatforms.push({
              text: masterModel.text,
              value: masterModel.value,
              masterModelId: masterModel.masterModelId,
            })
          }
        })
      return uniquePlatforms
    },
  },

  watch: {
    helpAboutSelectedRows(newValue) {
      const QSISliderElement = document.querySelector('.QSISlider')
      if (QSISliderElement) {
        QSISliderElement.style.display =
          newValue && newValue.length ? 'none' : ''
      }
    },
  },

  async created() {
    if (this.isDerivedParametersPageActive) {
      this.isDerivedParametersLoading = true
      await this[LC.GET_MASTER_MODELS]()
      await this[CA_DPC.GET_DERIVED_PARAMETERS](
        this.airlineId ? this.airlineId : null,
      ),
        await this[AOC.FIND_AIRLINES](this.airlineTiers),
        (this.isDerivedParametersLoading = false)
    }
  },
  methods: {
    ...mapActions(CA_DPC.NAMESPACE, [
      CA_DPC.GET_DERIVED_PARAMETERS,
      CA_DPC.UPDATE_DERIVED_PARAMETERS,
      CA_DPC.DELETE_DERIVED_PARAMETER,
    ]),
    ...mapActions(AOC.NAMESPACE, [AOC.FIND_AIRLINES]),
    ...mapActions(LC.NAMESPACE, [LC.GET_MASTER_MODELS]),

    handleTabChange(index) {
      // required for future integration with custom alerts
      this.tabIndex = index
    },

    cancelDelete() {
      this.showDeleteConfirmationDialog = false
      this.showDeleteParameterConfirmationToast = false
    },
    async handleDeleteParameterConfirmation() {
      this.isDerivedParametersLoading = true
      this[CA_DPC.DELETE_DERIVED_PARAMETER](this.selectedParametersToDelete)
        .then(async () => {
          this.showDeleteConfirmationDialog = false
          this.hideActionFooter = true
          await this[CA_DPC.GET_DERIVED_PARAMETERS](
            this.airlineId ? this.airlineId : null,
          )
          this.isDerivedParametersLoading = false
          this.hideActionFooter = false
          this.deleteParametersConfirmationToastDefinition = [
            {
              mode: 'toast',
              type: 'warning',
              text: 'Parameters(s) deleted',
              position: 'bottom',
              dismissible: true,
              hasToastAction: false,
              autoClose: true,
              icon: 'mdi-delete',
              duration: 6000,
            },
          ]
          this.showDeleteParameterConfirmationToast = true
        })
        .catch(() => {
          this.showDeleteConfirmationDialog = false
          this.isDerivedParametersLoading = false
          this.deleteParametersConfirmationToastDefinition = [
            {
              mode: 'toast',
              type: 'error',
              text: "Couldn't delete parameters(s) try again!",
              position: 'bottom',
              dismissible: true,
              hasToastAction: false,
              autoClose: true,
              icon: 'mdi-delete',
              duration: 6000,
            },
          ]

          this.showDeleteParameterConfirmationToast = true
        })
    },
    handleCopyParameter(whichParameter) {
      if (this.isRouterPushed) return
      this.$router
        .push({
          name: 'My Custom Parameter',
          params: {
            airlineId: whichParameter.airlineId,
            alertType: 'fullFlight',
            parameterID: whichParameter.id,
            masterModelId: whichParameter.masterModelId,
          },
          query: {
            airlineId: whichParameter.airlineId,
            alertType: 'fullFlight',
            isSingleAirlineUser: String(this.airlinesByTier.length === 1),
            masterModelId: whichParameter.masterModelId,
          },
        })
        .catch(err => {
          throw new Error(`Problem navigating: ${err}.`)
        })

      this.isRouterPushed = true
    },

    handleCloseDeleteParameterConfirmationmToast() {
      this.showDeleteParameterConfirmationToast = false
    },

    handleDeleteDerivedParameters(parametersToDelete) {
      this.selectedParametersToDelete = parametersToDelete
      this.hideActionFooter = false
      this.showDeleteConfirmationDialog = true
    },

    handleAddNewParameter() {
      // we need to add condition for the display of the dialog box
      if (this.airlinesByTier.length === 1) {
        // If user has only one airline then directly navigate to parameter details page
        if (this.getUniquePlatformsData.length === 1) {
          //hide airline and platforms dropdowns
          this.handleChooseAirline(
            this.airlinesByTier[0],
            this.getUniquePlatformsData[0],
          )
        } else if (this.getUniquePlatformsData.length > 1) {
          //hide the airlines and display platforms dropdown
          this.chooseAirlineDialogVisible = true
          this.displayAirline = false
          this.displayPlatform = true
          this.chooseAirlineTitle = 'Choose A Platform'
        }
      } else if (this.airlinesByTier.length > 1) {
        if (this.getUniquePlatformsData.length === 1) {
          this.chooseAirlineDialogVisible = true
          this.displayAirline = true
          this.displayPlatform = false
          this.chooseAirlineTitle = 'Choose An Airline'
        } else if (this.getUniquePlatformsData.length > 1) {
          this.chooseAirlineDialogVisible = true
          this.displayAirline = true
          this.displayPlatform = true
          this.chooseAirlineTitle = 'Choose An Airline And Platform'
        }
        //hide platform and display airline dropdown
      }
    },

    handleChooseAirlineDialogClose() {
      this.chooseAirlineDialogVisible = false
    },

    handleChangeSaveDisabled(value) {
      this.saveDisabled = value
    },

    async handleSaveAlert() {
      this.saveLoading = true
      this.saveDisabled = true
      this.hasSaved = true
    },

    handleChooseAirline(airlineItem, platformItem) {
      let airline = airlineItem ? airlineItem : this.airlinesByTier[0]
      let platform = platformItem
        ? platformItem
        : this.getUniquePlatformsData[0]
      if (airline && platform) {
        this.$router
          .push({
            name: 'My Custom Parameter',
            params: {
              airlineId: airline.airlineId,
              alertType: 'fullFlight',
              masterModelId: platform.masterModelId,
            },
            // Added to handle refresh issues where airline will be undefined on refresh
            query: {
              airlineId: airline.airlineId,
              alertType: 'fullFlight',
              isSingleAirlineUser: String(this.airlinesByTier.length === 1),
              masterModelId: platform.masterModelId,
            },
          })
          .catch(err => {
            throw new Error(`Problem navigating: ${err}.`)
          })
      }
    },
  },
}
</script>
